<section class="amedida">
  <!-- ===== Hero ===== -->
  <div class="amedida__hero ts-mosaic-band">
    <div class="amedida__wrap">
      <div class="amedida__eyebrow">
        <app-ts-piece piece="tr" variant="outline" color="var(--ts-primary)" [size]="18" />
        <span>Desarrollos a medida</span>
      </div>
      <h1 class="amedida__title">
        Lo que el estándar no cubre, ya lo hemos construido antes.
      </h1>
      <p class="amedida__lead">
        Software real, funcionando hoy en empresas como la tuya. Todo sobre la
        misma plataforma: tus datos, tu facturación y tu equipo siguen donde
        están, y encima construimos la pieza que te falta.
      </p>
      <div class="amedida__hero-cta">
        <a class="ts-btn ts-btn--dark" routerLink="/contacto">Cuéntanos tu caso</a>
        <a class="amedida__hero-link" routerLink="/soluciones"
          >Ver soluciones por sector →</a
        >
      </div>
    </div>
  </div>

  <!-- ===== Filtros por tipo ===== -->
  <div class="amedida__wrap amedida__filters">
    @for (t of tipos; track t) {
      <button
        type="button"
        class="amedida__chip"
        [class.amedida__chip--active]="activeTipo === t"
        (click)="setTipo(t)">
        {{ t }}
      </button>
    }
  </div>

  <!-- ===== Parrilla de casos ===== -->
  <div class="amedida__wrap amedida__grid">
    @for (c of filtered; track c.slug) {
      <a class="caso-card" [routerLink]="['/a-medida', c.slug]">
        <div
          class="caso-card__img"
          role="img"
          [attr.aria-label]="c.title"
          [style.background-image]="'url(' + c.cardImage + ')'"></div>
        <div class="caso-card__body">
          <span class="caso-card__type">
            <app-ts-piece
              piece="tr"
              [variant]="c.variante"
              color="var(--ts-primary)"
              [size]="15" />
            {{ c.tipo }}
          </span>
          <span class="caso-card__title">{{ c.title }}</span>
          <span class="caso-card__resumen">{{ c.resumen }}</span>
          <span class="caso-card__sector">{{ c.location }}</span>
          <span class="caso-card__link">Ver el caso →</span>
        </div>
      </a>
    }
  </div>

  <!-- ===== Cómo trabajamos ===== -->
  <div class="amedida__how ts-mosaic-band">
    <div class="amedida__wrap">
      <h2 class="amedida__h2">Sobre la plataforma, no desde cero</h2>
      <p class="amedida__h2-sub">
        Un desarrollo a medida no te saca de TodoSector: se construye encima. Por
        eso cuesta menos, llega antes y no hay que migrar nada.
      </p>
      <div class="amedida__steps">
        <div class="amedida-step">
          <span class="amedida-step__num">1</span>
          <span class="amedida-step__title">Nos cuentas tu caso</span>
          <span class="amedida-step__text"
            >Hablas con quien lo va a construir, no con un comercial. Si algo del
            catálogo ya lo resuelve, te lo decimos.</span
          >
        </div>
        <div class="amedida-step">
          <span class="amedida-step__num">2</span>
          <span class="amedida-step__title">Construimos tu pieza</span>
          <span class="amedida-step__text"
            >Tu desarrollo encaja con los módulos que ya usas: mismos clientes,
            misma facturación, mismo acceso.</span
          >
        </div>
        <div class="amedida-step">
          <span class="amedida-step__num">3</span>
          <span class="amedida-step__title">Crece con el resto</span>
          <span class="amedida-step__text"
            >Las mejoras de la plataforma te llegan igual que a todos. Tu pieza a
            medida no se queda atrás.</span
          >
        </div>
      </div>
    </div>
  </div>

  <!-- ===== CTA final ===== -->
  <div class="amedida__wrap amedida__cta">
    <h2 class="amedida__cta-title">¿Tu caso no se parece a ninguno?</h2>
    <p class="amedida__cta-text">
      Mejor. Los de arriba tampoco se parecían a nada cuando llegaron.
    </p>
    <div class="amedida__cta-actions">
      <a class="ts-btn ts-btn--dark ts-btn--lg" routerLink="/contacto"
        >Cuéntanos tu caso</a
      >
      <span class="amedida__cta-fine"
        >Sin compromiso · te respondemos personas, no formularios</span
      >
    </div>
  </div>
</section>
